<template>
  <div class="instructions">
    <p>{{ $t("components.user.identity_proof_input.instructions.title") }}</p>
    <ul>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.identity_proof_input.instructions.documents.drivers_license") }};
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.identity_proof_input.instructions.documents.health_card") }};
      </li>
      <li>
        <icons-check class="accepted" />
        {{ $t("components.user.identity_proof_input.instructions.documents.passport") }}.
      </li>
    </ul>
    <p>{{ $t("components.user.identity_proof_input.instructions.sharing_notice") }}</p>
    <forms-files-uploader
      :id="'identity_proof_' + communityUser.id"
      v-model="proofFiles"
      no-label
      class="mb-0"
      center
      :label="$t('communities.fields.identity_proof')"
      :disabled="loading"
      :field="'identity_proof'"
      required
    />
  </div>
</template>

<script>
import IconsCheck from "@/assets/icons/check.svg";

import FormsFilesUploader from "@/components/Forms/FilesUploader.vue";

export default {
  name: "IdentityProofInput",
  components: {
    "icons-check": IconsCheck,
    FormsFilesUploader,
  },
  props: {
    communityUser: {
      type: Object,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    proofFiles: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    submit(...params) {
      this.$emit("submit", ...params);
    },
  },
};
</script>
<style lang="scss" scoped>
.accepted {
  fill: $success;
}

.instructions {
  ul {
    list-style-type: none;
    padding-left: 1rem;
    li {
      margin-bottom: 0.25rem;
    }
  }
}
</style>
